// The ONE title treatment every reporting PANEL uses — the KPI tiles on both
// dashboards and the user-added widgets.
//
// ⚠️ WHY THIS IS A SHARED COMPONENT AND NOT FOUR COPIES OF A CLASS STRING. The
// tile/widget labels were `text-muted-foreground` while the section-card
// headings beside them ("Performance by campaign type", "Auction
// competitiveness", "Trend") were `font-semibold` at full contrast — so on one
// canvas, panels of the same standing were labelled two different ways and the
// smaller ones ("Conv. rate", "Cost / conv.") were the hard ones to read. A
// panel's title is what tells you what you are looking at; it is not secondary
// text. Routing all four through here is what stops the two treatments drifting
// apart again.
//
// It stays `text-xs`: these labels sit above a large figure that is the thing
// being read, and the fix was contrast + weight, not size.

import { cn } from '../../lib/utils';

/** The bare class, for the rare caller that cannot render this component. */
export const PANEL_TITLE_CLASS = 'text-xs font-semibold text-foreground';

export function PanelTitle({
  children,
  selected = false,
  className,
  title,
}: {
  children: React.ReactNode;
  /**
   * The tile is the big chart's metric selector; the selected one is tinted
   * Kyck green. Still full-weight — selection changes the hue, not the legibility.
   */
  selected?: boolean;
  className?: string;
  /** Native tooltip, for a label the panel is too narrow to show in full. */
  title?: string;
}): React.JSX.Element {
  return (
    <span
      title={title}
      className={cn(
        'min-w-0 truncate text-xs font-semibold',
        selected ? 'text-kyck-700' : 'text-foreground',
        className,
      )}
    >
      {children}
    </span>
  );
}
